/*
    🔥 CONFIRM — nativo del navegador

    Sin estética y sin dependencias. Está a propósito: es el respaldo
    que funciona aunque todo lo demás falle.

    requireText se resuelve con prompt(), que es lo más cercano que
    ofrece el navegador a un "escribí para confirmar".
*/

export const ConfirmNativeHost = () => null;

export const onConfirmNative = ({ title, text, requireText = null }) => {

    const MESSAGE = text ? `${title}\n\n${text}` : title;

    if (requireText) {
        const TYPED = window.prompt(`${MESSAGE}\n\nEscribí "${requireText}" para confirmar:`);
        return Promise.resolve(String(TYPED ?? '').trim() === String(requireText).trim());
    }

    return Promise.resolve(window.confirm(MESSAGE));
};
